import { create as createStore } from 'zustand';

type IUIState = {
  isRecapModalOpen: boolean;
  setIsRecapModalOpen: (isOpen: boolean) => void;
  showActivityReview: boolean;
  setShowActivityReview: (isOpen: boolean) => void;
  showNextActivityShortcut: boolean;
  setShowNextActivityShortcut: (show: boolean) => void;
};

const uiStateStore = createStore<IUIState>(set => ({
  isRecapModalOpen: false,
  setIsRecapModalOpen: (isOpen: boolean) => set({ isRecapModalOpen: isOpen }),
  showActivityReview: false,
  setShowActivityReview: (isOpen: boolean) => set({ showActivityReview: isOpen }),
  showNextActivityShortcut: false,
  setShowNextActivityShortcut: (show: boolean) => set({ showNextActivityShortcut: show })
}));

export const useActivityUIState = uiStateStore;
